import { createRequestHelper } from '@utils/swr'
import { type ECommercePaymentTransactionRequest } from '../types/apiRequest'
import { type PaymentTransactionResponse } from '../types/apiResponse'
import { type ECommerceV2Apis } from '../types/apis'

const { useRequest } = createRequestHelper<ECommerceV2Apis['get']['paymentTransaction'], PaymentTransactionResponse, ECommercePaymentTransactionRequest | null>({
  client: 'eCommerceV2',
  key: params => params?.payment_transaction_id ? `/${params.country_code}/payment_transactions/${params.payment_transaction_id}` : null,
  fetcher: client => (url, params) => client.get(url, {
    headers: {
      'Accept-Language': params?.language,
    },
  }),
})

export const useApiPaymentTransaction = useRequest
